import DropdownTemplateView from '../../DropdownTemplateView'
import Button from '../Button'
import messageResource from '../../messageResource'
import $ from 'jquery'
import {ModalAlertOffsets, ModalAlertPointerPosition} from './constants'
import {showElementAt} from '../../atBrowserUtils'
import {InvisibleMoire} from '../InvisibleMoire'
import ModalAlertLine from './ModalAlertLine'

export default class ModalAlert extends DropdownTemplateView {
    constructor({
        showCancelButton = false,
        onConfirm = () => {},
        okButtonLabel = messageResource.getMessage('common.ok'),
        onCancelButtonClick = () => {},
    } = {}) {
        super(null, {
            toggleMode: false,
        })

        this.params = {
            showCancelButton,
            onConfirm,
            okButtonLabel,
            onCancelButtonClick
        }

        this.state = {
            text: '',
            additionalClass: '',
            pointerPosition: ModalAlertPointerPosition.CENTER,

            offsets: {
                left: null,
                top: null,
            },

            showMoire: false,
        }

        this.onStatePropertyChanged('text', (text) => {
            this.$textPlaceholder.empty()
            text.split('\n').forEach(lineText =>
                new ModalAlertLine({
                    lineText
                }).init(this.$textPlaceholder)
            )
        })

        this.onStatePropertyChanged('additionalClass', (newAdditionalClass, oldAdditionalClass) => {
            this.$el.removeClass(oldAdditionalClass)
            this.$el.addClass(newAdditionalClass)
        })

        this.onStatePropertyChanged('showMoire', (show) => {
            this.moire.toggle(show)
        })
    }

    static getInstance() {
        return getInstance()
    }

    templateHtml() {
        return '<div class="components_modalAlert">' +
               '    <div class="content_modalAlert">' +
               '        <div class="iconPlaceholder"/>' +
               '        <div class="textPlaceholder"/>' +
               '        <div class="footer"/>' +
               '    </div>' +
               '    <div class="pointerPlaceholder">' +
               '        <div class="pointer"></div>' +
               '    </div>' +
               '</div>'
    }

    afterRender() {
        this.$textPlaceholder = this.find('.textPlaceholder')
        this.$pointer = this.find('.pointer')
        this.$footer = this.find('.footer')

        this.okButton = new Button({
            label: this.params.okButtonLabel,
            additionalClass: 'okButton',
            handleEnterKeydown: true,
            onClickCb: (e) => {
                this.params.onConfirm()
                this.hide()
            }
        }).init(this.$footer)
        if (this.params.showCancelButton) {
            this.cancelButton = new Button({
                label: messageResource.getMessage('common.cancel'),
                additionalClass: 'cancelButton',
                onClickCb: (e) => {
                    this.hide()
                    this.params.onCancelButtonClick()
                }
            }).init(this.$footer)
        }

        this.getEl().click(e => e.stopPropagation())

        this.moire = InvisibleMoire.getInstance()
        this.moire.getEl().click((e) => e.stopPropagation())
    }

    onHide() {
        super.onHide()
        this.moire.hide()
        this.onHideCb()
        this.params.onCancelButtonClick()
        this.setInitialState()
    }

    showAt(element, onHideCb = () => {}) {
        this.onHideCb = onHideCb
        this.moire.toggle(this.state.showMoire)
        super.showAt(element)
        this.okButton.focus()
    }

    _showElementAt($el, positionParams) {
        const leftOffset = this.state.offsets.left === null ? ModalAlertOffsets[this.state.pointerPosition].left : this.state.offsets.left
        const topOffset = this.state.offsets.top === null ? ModalAlertOffsets[this.state.pointerPosition].top : this.state.offsets.top
        super._showElementAt($el, {
            ...positionParams,
            my: this.state.pointerPosition + ' top',
            at: 'center bottom',
            offset: leftOffset + 'px ' + topOffset + 'px',
        })
        this._setPointer(positionParams.of, leftOffset)
    }

    mouseDownTargetElement() {
        return $('body')
    }

    _setPointer(elementShowAt, alertLeftOffset) {
        this.$pointer.removeClass('pointerUp pointerDown')

        const pointerOffset = -alertLeftOffset +
                              (this.state.pointerPosition === ModalAlertPointerPosition.RIGHT
                                      ? this.$el.width() / 2
                                      : (this.state.pointerPosition === ModalAlertPointerPosition.LEFT
                                          ? -this.$el.width() / 2
                                          : 0)
                              )
        const elementOffset = elementShowAt.offset().top
        const alertOffset = this.$el.offset().top
        let positionParams

        if (elementOffset < alertOffset) {
            //alert below element
            this.$pointer.addClass('pointerUp')
            positionParams = {
                of: this.$el,
                my: 'center bottom',
                at: 'center top',
                offset: pointerOffset + 'px 1px'
            }
        } else {
            this.$pointer.addClass('pointerDown')
            positionParams = {
                of: this.$el,
                my: 'center top',
                at: 'center bottom',
                offset: pointerOffset + 'px -1px'
            }
        }

        showElementAt(this.$pointer, positionParams)
    }

    setInitialState() {
        this.setState({
            pointerPosition: ModalAlertPointerPosition.CENTER,
            offsets: {
                left: null,
                top: null,
            },
        })
    }
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new ModalAlert().init($("body"))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/components/modalAlert/ModalAlert.js